import { getContactUsFormTemplate, getVueContactUsFormTemplate } from "../../shortcodes/templates";
import { DEFAULT_CONFIG, extractDataFromElement } from "../../shortcodeConfigs/contactUsFormConfig";

const decodeFromContactUsFormData = element => {
  if (!element) return {};

  try {
    return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
  } catch (e) {
    return {};
  }
};

const visualizeContactUsForm = content => {
  const contactUsFormWrappers = content.querySelectorAll('[data-wrapper-id="contact-us-form"]');

  if (contactUsFormWrappers.length > 0) {
    contactUsFormWrappers.forEach(wrapper => {
      // Check if it already has the new inline-editable structure
      const existingComponent = wrapper.querySelector('[data-tiny-mce-component="contact-us-form"]');

      if (existingComponent) {
        // Already has the new structure - extract current inline-edited values and re-render
        const currentData = extractDataFromElement(existingComponent);

        // Also get stored settings from data attribute
        const storedData = decodeFromContactUsFormData(wrapper.getAttribute("data-contact-us-form-data"));

        // Merge stored settings with extracted inline content
        const mergedData = {
          ...DEFAULT_CONFIG,
          ...storedData,
          ...currentData,
        };

        // Preserve the remove button
        const removeButton = wrapper.querySelector('[data-shortcode-remove-onclick]');
        const removeButtonHtml = removeButton ? removeButton.outerHTML : '<div data-shortcode-remove-onclick="true">x</div>';

        wrapper.innerHTML = removeButtonHtml + getContactUsFormTemplate(mergedData);
      } else {
        const vueComponent = wrapper.querySelector("contact-us-form");
        const vueData = vueComponent ? vueComponent.getAttribute("contact-us-form-data") : null;
        const decodedVueData = decodeFromContactUsFormData(vueData);

        const storedData = decodeFromContactUsFormData(wrapper.getAttribute("data-contact-us-form-data"));

        const mergedData = {
          ...DEFAULT_CONFIG,
          ...storedData,
          ...decodedVueData,
        };

        // Preserve the remove button
        const removeButton = wrapper.querySelector('[data-shortcode-remove-onclick]');
        const removeButtonHtml = removeButton ? removeButton.outerHTML : '<div data-shortcode-remove-onclick="true">x</div>';

        wrapper.innerHTML = removeButtonHtml + getContactUsFormTemplate(mergedData);
      }
    });
  }
};

const serializeContactUsForm = content => {
  const contactUsFormWrappers = content.querySelectorAll('[data-wrapper-id="contact-us-form"]');

  if (contactUsFormWrappers.length > 0) {
    contactUsFormWrappers.forEach(wrapper => {
      const contactUsFormElement = wrapper.querySelector('[data-tiny-mce-component="contact-us-form"]');

      if (contactUsFormElement) {
        // Extract all editable content from the inline-editable elements
        const extractedData = extractDataFromElement(contactUsFormElement);

        // Get stored form settings
        const storedData = decodeFromContactUsFormData(wrapper.getAttribute("data-contact-us-form-data"));

        // Merge everything - stored settings take precedence for non-content fields
        const formData = {
          // Content fields from inline editing
          sidebarTitle: extractedData.sidebarTitle,
          sidebarSubtitle: extractedData.sidebarSubtitle,
          phone: extractedData.phone,
          email: extractedData.email,
          address: extractedData.address,
          company: extractedData.company,
          buttonText: extractedData.buttonText,
          // Settings from stored data (or extracted if not stored)
          sendEmailToGroove: storedData.sendEmailToGroove ?? extractedData.sendEmailToGroove ?? DEFAULT_CONFIG.sendEmailToGroove,
          successMessage: storedData.successMessage || extractedData.successMessage || DEFAULT_CONFIG.successMessage,
          errorMessage: storedData.errorMessage || extractedData.errorMessage || DEFAULT_CONFIG.errorMessage,
          buttonBgColor: storedData.buttonBgColor || extractedData.buttonBgColor || DEFAULT_CONFIG.buttonBgColor,
          buttonTextColor: storedData.buttonTextColor || extractedData.buttonTextColor || DEFAULT_CONFIG.buttonTextColor,
          showSideBlock: storedData.showSideBlock ?? extractedData.showSideBlock ?? DEFAULT_CONFIG.showSideBlock,
          sideBlockBgColor: storedData.sideBlockBgColor || extractedData.sideBlockBgColor || DEFAULT_CONFIG.sideBlockBgColor,
          sideBlockTextColor: storedData.sideBlockTextColor || extractedData.sideBlockTextColor || DEFAULT_CONFIG.sideBlockTextColor,
          nameLabel: storedData.nameLabel || extractedData.nameLabel || DEFAULT_CONFIG.nameLabel,
          emailLabel: storedData.emailLabel || extractedData.emailLabel || DEFAULT_CONFIG.emailLabel,
          messageLabel: storedData.messageLabel || extractedData.messageLabel || DEFAULT_CONFIG.messageLabel,
          namePlaceholder: storedData.namePlaceholder ?? extractedData.namePlaceholder ?? DEFAULT_CONFIG.namePlaceholder,
          emailPlaceholder: storedData.emailPlaceholder ?? extractedData.emailPlaceholder ?? DEFAULT_CONFIG.emailPlaceholder,
          messagePlaceholder: storedData.messagePlaceholder ?? extractedData.messagePlaceholder ?? DEFAULT_CONFIG.messagePlaceholder,
        };

        // Encode the data for the Vue component
        const encodedData = window.btoa(escape(encodeURIComponent(JSON.stringify(formData))));

        // Replace with Vue component
        wrapper.innerHTML = getVueContactUsFormTemplate(encodedData);
      } else {
        // Fallback: use stored data if no inline component found
        const formData = wrapper.getAttribute("data-contact-us-form-data") || "";
        wrapper.innerHTML = getVueContactUsFormTemplate(formData);
      }
    });
  }
};

export { visualizeContactUsForm, serializeContactUsForm };
